import React, { useState } from 'react';

interface NoticeItem {
  id: number;
  title: string;
  content: string;
  date: string;
  category: string;
  isImportant: boolean;
}

const NoticePage: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [openItems, setOpenItems] = useState<number[]>([]);

  const noticeData: NoticeItem[] = [
    {
      id: 1,
      title: "📢 폰피쉬 9월 1일 정식 오픈 안내",
      content: "컬러렌즈 쇼핑 더 선명하게, 폰피쉬\n\n9월 1일, 정식 오픈합니다! 🎉\n\n✔️ AR 피팅으로 내 눈에 직접 착용해보기\n✔️ 다양한 브랜드 렌즈 한 곳에서 비교하기\n✔️ 모바일 앱에서 더 쉽고 빠르게 쇼핑하기\n\n이제 컬러렌즈 쇼핑, 폰피쉬에서 새롭게 경험하세요.",
      date: "2024-09-01",
      category: "운영안내",
      isImportant: false
    }
  ];

  const categories = ['all', '서비스점검', '정책변경', '업데이트', '운영안내', '보안'];

  const filteredNotices = selectedCategory === 'all' 
    ? noticeData 
    : noticeData.filter(notice => notice.category === selectedCategory);

  const toggleItem = (id: number) => {
    setOpenItems(prev => 
      prev.includes(id) 
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
  };

  return (
    <div className="min-h-screen bg-white py-6">
      <div className="max-w-4xl mx-auto px-4 sm:px-24 lg:px-4">
        <div className="bg-white px-4 py-8">
          <h1 className="text-3xl font-bold text-black mb-8 text-center">
            공지사항
          </h1>

          {/* 카테고리 필터 */}
          {/* 
          <div className="mb-8">
            <div className="flex flex-wrap gap-2 justify-center">
              {categories.map(category => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-full text-base font-medium transition-colors ${
                    selectedCategory === category
                      ? 'bg-black text-white'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                >
                  {category === 'all' ? '전체' : category}
                </button>
              ))}
            </div>
          </div>
          */}

          {/* 공지사항 목록 */}
          <div className="space-y-4">
            {filteredNotices.map(notice => (
              <div key={notice.id} className={`border rounded-lg ${
                notice.isImportant ? 'border-red-300 bg-red-50' : 'border-gray-200'
              }`}>
                                  <button
                    onClick={() => toggleItem(notice.id)}
                    className="w-full px-4 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                  >
                    <div className="flex items-center space-x-2">
                      {notice.isImportant && (
                        <span className="px-2 py-1 bg-red-500 text-white text-sm font-medium rounded-full whitespace-nowrap">
                          중요
                        </span>
                      )}
                      <div className="text-left">
                        <h3 className={`font-medium text-lg break-keep break-words pr-1 ${
                          notice.isImportant ? 'text-red-900' : 'text-black'
                        }`}>
                          {notice.title}
                        </h3>
                        <p className="text-sm text-gray-600 mt-1">
                          {notice.date} • {notice.category}
                        </p>
                      </div>
                    </div>
                    <span className={`text-gray-600 transition-transform ${
                      openItems.includes(notice.id) ? 'rotate-180' : ''
                    }`}>
                      ▼
                    </span>
                  </button>
                  {openItems.includes(notice.id) && (
                    <div className="px-4 pb-4 border-t border-gray-200">
                      <p className="text-black pt-4 whitespace-pre-line text-base leading-relaxed break-keep break-words">{notice.content}</p>
                    </div>
                  )}
              </div>
            ))}
          </div>

          {/* 공지사항이 없을 때 */}
          {filteredNotices.length === 0 && (
            <div className="text-center py-12 text-gray-600">
              <p>해당 카테고리의 공지사항이 없습니다.</p>
            </div>
          )}

          {/* 추가 문의 안내 */}
          <div className="mt-12 p-6 bg-gray-100 rounded-lg text-center">
            <h3 className="text-lg font-semibold text-black mb-2">
              더 자세한 정보가 필요하신가요?
            </h3>
            <p className="text-black mb-4">
              공지사항과 관련하여 궁금한 점이 있으시면<br />고객센터로 문의해 주세요.
            </p>
            <div className="text-sm text-gray-700 space-y-1">
              <p>이메일: cs@ponpish.kr</p>
              <p>카카오톡 상담: @ponpish</p>
              <p>운영시간: 평일 10:00 - 18:00</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoticePage;
